const notification = ({ label, isDialog, isEvent, description }) => {
  if (isDialog) {
    return {
      label,
      isDialog,
    };
  }
  if (isEvent) {
    return {
      label,
      isEvent,
      tooltip: description,
    };
  }

  return label;
};

const dialog = (label) =>
  notification({ label, isDialog: true, isEvent: false });
const event = (label, description) =>
  notification({ label, isDialog: false, isEvent: true, description });

export { dialog, event, notification };
